import {
  aadharPlaceholder,
  birthCertificate,
  transferCertificate,
} from "../../../asset";
import DocumentUpload from "../../../components/common/DocumetUpload";
import { Student } from "../../../types/studentType";

export default function StudentDocumentDetails({
  data,
  setFormData,
}: {
  data: Partial<Student>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Student>>>;
}) {
  const handleUpload = (field: keyof Student, url: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: url,
    }));
  };

  return (
    <div className="grid gap-y-24 lg:grid-cols-3 pb-20 gap-10">
      <DocumentUpload
        label="Birth Certificate"
        placeholderImage={birthCertificate}
        value={data.birthCertificateUrl || ""}
        onUploadComplete={(url) =>
          handleUpload("birthCertificateUrl", url)
        }
        borderStyle="solid"
        buttonText="Upload"
      />

      <DocumentUpload
        label="Transfer Certificate"
        placeholderImage={transferCertificate}
        value={data.transferCertificateUrl || ""}
        onUploadComplete={(url) =>
          handleUpload("transferCertificateUrl", url)
        }
        borderStyle="solid"
        buttonText="Upload"
      />

      <DocumentUpload
        label="Aadhar Card"
        placeholderImage={aadharPlaceholder}
        value={data.aadharCardUrl || ""}
        onUploadComplete={(url) =>
          handleUpload("aadharCardUrl", url)
        }
        borderStyle="solid"
        buttonText="Upload"
      />
    </div>
  );
}
